import React, { useState, useEffect, useContext } from 'react';
import { Table, Button, Select, Input, message, Typography, Breadcrumb, Row, Col, Divider, Space, TableProps } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { Form } from 'antd';
import { DeleteReviewUsers, fetchEmpDetails, FetchReviewGroup, FetchReviewUsers,SaveReviewUsers } from '../../../core/services/account-request.service';
import { ReviewSetup } from '../../../core/interfaces/ReviewSetup';
import { Group } from '../../../core/interfaces/Group';
import { Approval } from '../../../core/interfaces/Approval';
import Modal from 'antd/es/modal/Modal';
import { Employee } from '../../../core/interfaces/Employee';
import { CalClient } from '@cvx/cal';
import { environment } from "../../../environments/environment";
import { User } from '../../../core/interfaces/User';
import { UserContext } from '../../../context/user-context';
import { appInsights } from '../../../core/services/insight.service';
import GlobalErrorMessage from '../../global-error/GlobalErrorMessage';

const { Title } = Typography;
const { Option } = Select;

const ReviewerSetup: React.FC = () => {
  const [users, setUsers] = useState<ReviewSetup[]>([]);
  const [groups, setGroups] = useState<Group[]>([]);
  const [selectedUser, setSelectedUser] = useState<string | null>(null);
  const [selectedGroup, setSelectedGroup] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [searchResults, setSearchResults] = React.useState<Approval>({} as Approval); 
  const [deleteResult, setDeleteResult] = React.useState<void>(); 
  const [open,setOpen] = useState(false);
  const [empData, setEmpData] = useState<Employee[]>([]);
  const cal = new CalClient(environment.calConfig);
  const [graphUser, setGraphUser] = useState<User>({});
  const user = useContext(UserContext);
  const [result, setResult] = React.useState<string | undefined>(); 
  const [apiError, setApiError] = useState(null);
  const userProfile = useContext(UserContext);
    
    const getUserEmail = async () => {
      try {
        const response = await cal.getUserPropertiesFromMsGraph([
          "userPrincipalName"
        ]);
        setGraphUser((prev) => ({ ...prev, ...user }));
        setGraphUser((prev) => ({ ...prev, Emaild: response.userPrincipalName }));
        appInsights.trackEvent({ name: "Get User Email Success", properties: { userId: user.email } });
      } catch (error) {
        setApiError(error);
        appInsights.trackException({ exception: error as Error, properties: { Component:'ReviewSetup', method:'getUserEmail', context: 'Get User Email', userId: user.email } }); // Track exception
      }
    };
  const navigate = useNavigate();
  useEffect(() => {
        //Fetch Initial Data
        loadGroups();
        loadUsers();
        getUserEmail();
  }, []);

  const loadGroups = async () => {
    setLoading(true);
    try {
      const response = await FetchReviewGroup(userProfile); // Replace with actual API endpoint
      setGroups(response);
      appInsights.trackEvent({ name: "Fetch Review Group Success", properties: { userId: user.email } });
    } catch (error) {
      setApiError(error);
      message.error('Failed to load groups');
      appInsights.trackException({ exception: error as Error, properties: { Component:'ReviewSetup', method:'loadGroups', context: 'Load Groups', userId: user.email } }); // Track exception
    }
    finally {
      setLoading(false);
    }
  };

  const loadUsers = async () => {
    setLoading(true);
    try {
      const response = await FetchReviewUsers(userProfile); // Replace with actual API endpoint
      setUsers(response);
      appInsights.trackEvent({ name: "Fetch Review Users Success", properties: { userId: user.email } });
    } catch (error) {
      setApiError(error);
      message.error('Failed to load users');
      appInsights.trackException({ exception: error as Error, properties: { Component:'ReviewSetup', method:'loadUsers', context: 'Load Users', userId: user.email } }); // Track exception
    }
    finally {
      setLoading(false);
    }
  };
  

  const handleSave = async () => {
    if (!selectedUser) {
      message.error('User Email ID is required');
      return;
    }
    if (!selectedGroup) {
      message.error('Select approval group');
      return;
    }
    const emailExists = users.some((user) => user.emailID === selectedUser && user.appgroup === selectedGroup);
    if (emailExists) {
      message.error("This email already exists in the list of Review Setup users.");
      return;
    }
    const response = await fetchEmpDetails(selectedUser);
    setResult(response.length > 0 ? response[0].fullName : undefined);
    const data: Approval = {
    cai: selectedUser,
    name: response.length > 0 ? response[0].fullName : "",
    appgroup: selectedGroup,
    emailID: selectedUser,
    sponsorEmailID: graphUser.email || "",
    }
    try {
        const response = await SaveReviewUsers(data, userProfile); // Adjust the API endpoint as needed
        setSearchResults(response);
        setLoading(true);
        message.success('User saved successfully');
        loadUsers();
        setSelectedUser(null);
        setSelectedGroup(null);
        appInsights.trackEvent({ name: "Save Review Users Success", properties: { userId: user.email, selectedUser: selectedUser, selectedGroup: selectedGroup } });
    }
    catch (error) {
      setApiError(error);
      message.error('Failed to save user');
      appInsights.trackException({ exception: error as Error, properties: { Component:'ReviewSetup', method:'handleSave', context: 'Handle Save', userId: user.email, selectedUser: selectedUser, selectedGroup: selectedGroup } }); // Track exception
    }
  };
 
  const handleDelete = async () => {
    if (!selectedUser) {
      message.error('User Email ID is required');
      return;
    }
    const emailID = selectedUser;
    if (!selectedUser) {
      message.error('User Email ID is required');
      return;
    }
    try {
      const response = await DeleteReviewUsers(emailID,userProfile); // Adjust the API endpoint as needed
      setDeleteResult(response);
      setLoading(true);
      message.success('User deleted successfully');
      loadUsers();
      setSelectedUser(null);
      setSelectedGroup(null);
      appInsights.trackEvent({ name: "Delete Review Users Success", properties: { userId: user.email, selectedUser: selectedUser } });
    } catch (error) {
      setApiError(error);
      message.error('Failed to delete user');
      appInsights.trackException({ exception: error as Error, properties: { Component:'ReviewSetup', method:'handleDelete', context: 'Handle Delete', userId: user.email, selectedUser: selectedUser } }); // Track exception
    }
  };
   const handleReset = async () => {
        setSelectedUser(null);
        setSelectedGroup(null);
  };
  const RedirectLink = async (e: any, record: ReviewSetup) => {
    e.preventDefault();
    const emailID = record.emailID;
    const group = groups.find(group => group.groupName === record.approvalGroupName);
    if (group) 
    {
      setSelectedGroup(group.groupId);
    }
    if (emailID) 
    {
      setSelectedUser(emailID);
    }
  };
  const column : TableProps<Employee>['columns']  = [
    {
        title: "S/N",
        dataIndex: "index",
        key: "index",
        render: (text: string, record: Employee, index: number) =>
        `${index + 1}.`,
        width:'15%'
    },
    {
      title: 'Name',
      dataIndex: 'fullName',
      key: 'fullName',
      render:(text)=> <a >{text}</a>,
      width: '20%',
    },
    {
      title: 'User ID/Email ID',
      dataIndex: 'emailAddress',
      key: 'emailAddress',
      align: 'center',
      width: '20%',
    },
    {
      title: 'PhoneExt',
      dataIndex: 'phoneExt',
      key: 'phoneExt',
      width: '15%',
    },
    
    {
      title: 'Department',
      dataIndex: 'deptName',
      key: 'deptName',
      width: '20%',
    },
    {
      title: 'Location',
      dataIndex: 'locationName',
      key: 'locationName',
      width: '20%',
    },
  ];

  const columns = [
    {
      title: 'S/N',
      dataIndex: 'sn',
      key: 'sn',
      render: (text: string, record: ReviewSetup, index: number) => `${index + 1}.`,
    },
    {
      title: 'Email ID',
      dataIndex: 'emailID',
      key: 'emailID',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text: string, record: ReviewSetup) => <a href={`/administration/review-setup`} onClick={(event) => RedirectLink(event, record)}>{text}</a>,
    },
    {
      title: 'Approval Group',
      dataIndex: 'approvalGroupName',
      key: 'approvalGroupName',
    },
  ];

 const setRequester = (text:string) => {
    setSelectedUser(text);
    setOpen(false);
    setEmpData([]);
 }
  const showModal = async(e: any) => {
    setSelectedUser(e);
    setOpen(true);
    if (e && e.trim() !== "") {
      await SearchUser(e);
    } else {
      setEmpData([]);
    }
  };  
  const SearchUser = async(text:any) => {
    setLoading(true);
    try {
        const response = await fetchEmpDetails(text); // Adjust the API endpoint as needed
        setEmpData(response);
        appInsights.trackEvent({ name: "Search User Success", properties: { userId: user.email, searchText: text } });
      } catch (error) {
        setApiError(error);
        message.error("Failed to fetch users");
        appInsights.trackException({ exception: error as Error, properties: { Component:'ReviewSetup', method:'SearchUser', context: 'Search User', userId: user.email, searchText: text } }); // Track exception
      } finally {
        setLoading(false);
      }  
};
  const handleOk = async(e: any) =>  {
    setOpen(false);
    }

  const handleCancel = async(e: any) =>  {
    setOpen(false)
  }

  function handleModalInputChange(e: string): void {
    setSelectedUser(e);
  }
  const handleRetry = () => {
    setApiError(null);
  };
  return (
    <>
      <Breadcrumb
        items={[
          {
            title: "administration",
          },
          {
            title: "reviewer setup",
          },
        ]}
      />
       {apiError ? (
         <GlobalErrorMessage 
         error={apiError}
         visible={!!apiError}
         onClose={() => setApiError(null)}
         onRetry={handleRetry}
       />
       ) : (
      <div className="div-container">
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
      <Col span={12} offset={6}>
        <Title level={3}>Reviewer Setup</Title>
      </Col>
      </Row>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
      <Col span={24}>
        <Table dataSource={users} columns={columns} rowKey="email" loading={loading} />
      </Col>
      </Row>
      <div style={{ marginTop: '20px' }}>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col>
        <Form.Item>
          <Input
            placeholder="Approval Email ID"
            value={selectedUser|| ""}
            onChange={(e) => setSelectedUser(e.target.value)}
            style={{ width: '200px', marginRight: '10px' }}/>
            <a onClick={() => showModal(selectedUser)}>
            <SearchOutlined />
            </a>
          </Form.Item>
          </Col>
          <Col>
          <Form.Item>
          <Select
            placeholder="Select Approval Group"
            value={selectedGroup !== null ? selectedGroup : undefined}
            onChange={(value: number) => setSelectedGroup(value)}
            style={{ width: '200px', marginRight: '10px' }}
          >
            {groups.map((group) => (
              <Option key={group.groupId} value={group.groupId}>
                {group.groupName}
              </Option>
            ))}
          </Select>
          </Form.Item>
          </Col>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col>
          <Form.Item>
          <Button  onClick={handleReset} style={{ marginRight: '10px' }}>
            Reset
          </Button>
          <Button type="primary" onClick={handleSave} style={{ marginRight: '10px' }}>
            Save
          </Button>
          <Button danger onClick={handleDelete} style={{ marginRight: '10px' }}>
            Delete
          </Button>
          <Button onClick={() => navigate('/home')}>Exit</Button>
          </Form.Item>
          </Col>
          </Row>
          </Row>
        </div>
        <Modal
        title="Search For Employee"
        open={open}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1000}
        >
            <Divider></Divider>
            <Space direction="vertical">
            <Row gutter={[16,32]} >
                <Col span={16}>
                    <div>Enter Search Query</div>
               </Col>
            </Row>
            <Row gutter={[16,32]}>
                <Col span={18}>
                    <div >
                    <Input value={selectedUser|| ""} onChange={(e) => handleModalInputChange(e.target.value)}/>
                    </div>
                </Col>
                <Col span={6}>
                    <div >
                    <Button type="primary" onClick={()=>SearchUser(selectedUser)}>Search</Button>
                    </div>
                </Col>
            </Row>
                 
            </Space>
            
            <Table
                dataSource={empData}
                columns={column}
                pagination={false}
                scroll={{ y: 150 }}
                loading={loading}
                locale={{ emptyText: 'No matching record found. Kindly refine your criteria!' }}
                onRow={(record) => ({
                    onClick: () => setRequester(record.emailAddress),
                  })}
                style={{marginTop: '20px'}}
                size='small'
                />

            <Divider></Divider>
      </Modal>
        </div>)}
        </>
  );
};

export default ReviewerSetup;

